import { createTransport } from "../../public/shared/companion/guestChatTransport.js";
import type { EpicMobileApi } from "./api";

// The browser and native app share the request identity, reconciliation and
// allowance implementation. This adapter only selects the native boundary.
export function createMobileGuestTransport(api: EpicMobileApi, storage?: Storage) {
  return createTransport({ api: { request: (path, options) => api.guestRequest(path, options) },
    ...(storage ? { storage } : {}) });
}
